import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { ItemsWon } from "./ItemsWon";
import { StringValue } from "./StringValue";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="CG Run">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringValue
          label={"Farming Hero"}
          value={task.taskstatusdetail.atkheroname}
        />
        <StringValue
          label={"Doing Guardian For City"}
          value={task.taskstatusdetail.targetcity.cityname}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Currently Farming Items:"}
          value={`${task.taskstatusdetail.itemNameOfItemNeededToBeFarmed}:${
            task.taskstatusdetail.noOfItemsNeededToBeFarmed
          }`}
        />
        <ItemsWon task={task} label={"Farmed Items Won:"} />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
